import { Clock, Euro, GraduationCap, Users } from 'lucide-react';
import type { TrainingSummary as TrainingSummaryType } from '../../services/trainingLogApi';

interface Props {
    summary: TrainingSummaryType | null;
    showEmployeeCount?: boolean;
}

export function TrainingSummary({ summary, showEmployeeCount = false }: Props) {
    if (!summary) return null;

    const cards = [
        {
            label: 'Trainings',
            value: summary.TrainingCount,
            icon: GraduationCap,
            format: (v: number) => String(v),
        },
        {
            label: 'Total Hours',
            value: summary.TotalHours,
            icon: Clock,
            format: (v: number) => v.toFixed(1) + 'h',
        },
        {
            label: 'Total Costs',
            value: summary.TotalCostsEur,
            icon: Euro,
            format: (v: number) => '€ ' + v.toLocaleString('de-CH', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
        },
    ];

    if (showEmployeeCount) {
        cards.push({
            label: 'Employees',
            value: summary.UniqueEmployees,
            icon: Users,
            format: (v: number) => String(v),
        });
    }

    return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
            {cards.map((card) => (
                <div key={card.label} className="bg-white rounded-lg border border-gray-200 p-4">
                    <div className="flex items-center gap-2 text-gray-500 text-sm mb-1">
                        <card.icon className="w-4 h-4" />
                        <span>{card.label}</span>
                    </div>
                    <div className="text-2xl font-semibold text-gray-900">
                        {card.format(card.value)}
                    </div>
                </div>
            ))}
        </div>
    );
}
